import React from 'react';
import { getHtml } from 'helper/html';

const contentDefaults = {
    'cylinder.marketVolatilitySurchargeExplanation': <p>When you buy gas from us in a cylinder, an automatic ‘market volatility charge’ will be added to your basket. This is applied once per cylinder and the charge may move up or down over time due to ongoing changes in the global energy market.</p>,
}

const content = {
    content: null,
    set(content) {
        this.content = content;
    },
    get(identifier, defaultContent) {
        if (this.content !== null && typeof this.content[identifier] !== 'undefined' && String(this.content[identifier]).length) {
            return this.content[identifier];
        }
        if (typeof defaultContent !== 'undefined') {
            return defaultContent;
        }
        return typeof contentDefaults[identifier] !== 'undefined' ? contentDefaults[identifier] : undefined;
    },
    getReplaced(content, replacements) {
        if (typeof content === 'object') {
            return content;
        }
        content = String(content);
        Object.entries(replacements).forEach(([replacement, replacementValue]) => {
            content = content.replace('{' + replacement + '}', replacementValue)
        });
        return content;
    },
    text(identifier, defaultText, replacements = {}) {
        return this.getReplaced(this.get(identifier, defaultText), replacements);
    },
    html(identifier, defaultText = undefined, replacements = {}, className = 'html-content') {
        let html = this.getReplaced(this.get(identifier, defaultText), replacements);
        // For JSX defaults
        if (typeof html === 'object') {
            return html;
        }
        return <div className={ className }>{ getHtml(this.getReplaced(html, replacements)) }</div>;
    }
}
export default content;